module.exports = {
  SET_PRODUCTS: "SET_PRODUCTS",
  SET_ALL_PRODUCTS_BY_MATEERIAL: "SET_ALL_PRODUCTS_BY_MATEERIAL",
  SET_EDITABLE_PRODUCT: "SET_EDITABLE_PRODUCT",
  CLEAR_PRODUCT_STATE: "CLEAR_PRODUCT_STATE",
  SET_ALL_PRODUCTS: "SET_ALL_PRODUCTS"
}